module.exports = __webpack_public_path__ + "static/media/index-mob-1.d5d536b8.png";